import qs from "qs";
import type { FetchOptions as OFetchOptions } from 'ofetch';
interface FetchOptions extends OFetchOptions {
    baseURL?: string;
    params?: Record<string, any>;
    server?: boolean;
    useSanctum?: boolean;
}

export default async <T>(url: string, options: FetchOptions | undefined = undefined): Promise<T> => {
    // Destructure options to separate params and other fetch options
    const config = useRuntimeConfig();
    let baseURL, params, rest;

    if (typeof options !== 'undefined') {
        ({ baseURL, params, ...rest } = options);
    }

    const LOCAL_FETCH_API_URL = config.public.localFetchApiUrl;
    const remote_url = config.public.apiBase + url;

    // Stringify the params using qs
    const queryString = qs.stringify(params, { encodeValuesOnly: true });

    // Construct the full URL with query string
    const fullUrl = LOCAL_FETCH_API_URL + (queryString ? `${remote_url}&${queryString}` : remote_url);

    // Use the standard useFetch method with the modified URL
    const result = await $fetch(fullUrl, {
        credentials: "include",
        ...rest,
    });

    return result as T;
};